export default __webpack_public_path__ + "static/media/close_with_bg.3888118c.svg";